module.exports = __webpack_public_path__ + "zilla-slab-latin-500.52f6880fae093ec3054f17794988bc8a.woff2";